import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import OnScrollToChild from '@wix/da-shared-react/pkg/OnScrollToChild';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import FolderContent from '../FolderContent';
import { getStickyContentHeight } from '../../helpers';
import { getGallectionsStickyBarHeight } from '../helpers';

import s from './FolderContentList.scss';

export interface Props {
  folderIds: number[];
  onScrollToFolder: (folderId: number) => void;
  className?: string;
  isMobile?: boolean;
}

class FolderContentList extends React.Component<Props & WithTranslation> {
  render() {
    const { folderIds, t, isMobile } = this.props;

    const scrollOffsetTop =
      getStickyContentHeight(isMobile) +
      getGallectionsStickyBarHeight(isMobile);

    return (
      <OnScrollToChild
        offsetTop={scrollOffsetTop}
        onScrollToChild={this.onScrollToChild}
      >
        {folderIds.map((folderId, index) => (
          <div
            id={folderId.toString()}
            key={folderId}
            className={s['folder-content-wrapper']}
          >
            <FolderContent key={folderId} folderId={folderId} />
            {index < folderIds.length - 1 && (
              <div className={s['folder-content-separator']}>
                {t!('pages.gallections.youMightLikeThis')}
              </div>
            )}
          </div>
        ))}
      </OnScrollToChild>
    );
  }

  onScrollToChild = (id: string) => {
    this.props.onScrollToFolder(+id);
  };
}

export default withMobileContext(
  withTranslation()(FolderContentList)
) as React.ComponentType<Props>;
